export class Device {
    deviceInfo: DeviceInfo;
    isMobile: boolean;
    isTablet: boolean;
    isDekstop: boolean;
    deviceType: DeviceType
}

export interface DeviceInfo {
    userAgent: string;
    os: string;
    browser: string;
    device: string;
    os_version: string;
    browser_version: string;
}

export enum DeviceType {
    MOBILE,
    TABLET,
    DESKTOP
}